@if (formState() && formGroup() && activeSection()) {
  <ng-container *transloco="let t">
    <!--
      Below md the form column dissolves (contents) so its questions, the interactive modules and the
      navigation stack in that order: the modules belong to the questions, the navigation closes the form.
    -->
    <div class="flex min-h-0 flex-1 gap-4 max-md:flex-col">
      <div class="flex min-h-0 min-w-0 flex-1 flex-col max-md:contents">
        <div
          class="flex flex-1 flex-col overflow-y-auto"
          data-testid="form-content"
          tuiFade="vertical"
          [pxcSlideIn]="slideDirection()">
          <progress
            class="mb-4 mt-2"
            data-testid="progress-bar"
            size="s"
            tuiProgressBar
            [max]="sections().length"
            [segments]="sections().length"
            [tuiProgressColorSegments]="sectionColors()"
            [value]="sections().length + 1"></progress>
          <p class="text-sm text-text-tertiary">
            {{t('Questionnaire {{ index }} sur {{ total }}' , { index: activeSectionIndex() + 1 , total:
            sections().length})}}
          </p>

          @let sectionFormGroup = formGroup().get(activeSection().id);

          <form class="flex flex-col gap-4 py-2" data-testid="form" [formGroup]="formGroup()!">
            @if (sectionFormGroup) {
              <pxc-form-section
                [formInputs]="formInputs()"
                [readOnly]="readOnly()"
                [section]="activeSection()"
                [sectionGroup]="sectionFormGroup"
                (moduleReset)="onModuleReset($event)"
                (moduleTriggered)="onModuleTriggered($event)" />
            }
          </form>

          @for (autoModule of autoModules(); track autoModule.targetId + '::' + autoModule.moduleId) {
            <pxc-form-auto-trigger
              [autoModule]="autoModule"
              [moduleInputs]="formInputs()"
              (moduleTriggered)="onModuleTriggered($event)" />
          }
        </div>

        <div class="mt-4 flex gap-2 max-md:order-last max-md:mt-0 max-sm:flex-col-reverse max-sm:items-stretch">
          <button
            appearance="outline"
            class="sm:mr-auto"
            data-testid="previous-button"
            tuiButton
            type="button"
            (click)="previous()">
            {{ isActiveSectionFirst() ? t('Annuler') : t('Précédent') }}
          </button>
          <button
            data-testid="finish-button"
            tuiButton
            type="button"
            [appearance]="!isActiveSectionLast() ? 'secondary' : 'primary'"
            (click)="finish()">
            {{ t(finishText()) }}
          </button>

          @if (!isActiveSectionLast()) {
            <button data-testid="next-button" tuiButton type="button" (click)="next()">
              {{ t('Suivant') }}
            </button>
          }
        </div>
      </div>

      @if (interactiveModules().length) {
        <aside
          class="flex shrink-0 flex-col gap-4 md:w-96"
          data-testid="interactive-modules"
          [pxcSlideIn]="slideDirection()">
          @for (interactiveModule of interactiveModules(); track interactiveModule.moduleId) {
            <pxc-form-interactive-module class="flex min-h-0 flex-1 flex-col" [moduleConfig]="interactiveModule" />
          }
        </aside>
      }
    </div>
  </ng-container>
}
